/* eslint-disable camelcase */
import type {unstable_GqlError as GqlError} from '@sail/data';
/* eslint-enable camelcase */
import getErrorCode from '../../../../shared/graphql/utils/getErrorCode';
import type {
  MetaResponse,
  ErrorResponse,
} from '../../../../shared/graphql/links/RestLink/types';

export default function rebuildErrorFromResponse(
  maybeBody: ErrorResponse | null,
  maybeMeta: MetaResponse,
): GqlError {
  const maybeError = maybeBody?.error || maybeBody;
  const maybeCode = (maybeError && getErrorCode(maybeError)) || null;
  const message = maybeError?.message ?? 'An unknown error has occurred.';
  const status = maybeMeta.status;

  let code = 'could_not_get_error_code';

  if (status <= 0) {
    code = 'network_error';
  } else if (maybeCode) {
    code = maybeCode;
  }

  const extensions = {
    actionId: null,
    traceId: null,

    error: {
      code,
      // We need HTTP status code to discern 5xx errors from others in RestLink.
      // Once discerned, they're moved onto onError callback instead of onNext.
      // We then remove the status property so that API consumers don't have access to it.
      status,
    },

    // These props come from the backend but they don't come in the
    // HTTP body. V2 link extracts them too and puts them in the error
    // body so that the observability link can read them.
    unstable_requestId: maybeMeta.requestId,
  };

  return {
    message,
    path: [maybeMeta.field],
    extensions,
  };
}
